import { render } from "./EditorBar.vue?vue&type=template&id=7809a8d6&ts=true"
import script from "./EditorBar.vue?vue&type=script&lang=ts"
export * from "./EditorBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__